<template>
  <div>
    <AllPhysicians :selectedStatuses="statuses"></AllPhysicians>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllPhysicians = defineAsyncComponent(() =>
  import("@/components/physicians/AllPhysicians")
);
export default {
  components: {
    AllPhysicians,
  },
  data() {
    return {
      statuses: "ACTIVE",
    };
  },
};
</script>
